var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.supply && _vm.supply.tariff)?_c('div',[_c('pre',[_vm._v("    "+_vm._s(JSON.stringify(_vm.supply.tariff, null, 4))+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }